<template>
  <div>
    <v-snackbar
      v-model="message.snackbar"
      :timeout="message.snackbarTimeout"
      bottom
    >
      {{ message.snackbarText }}
      <v-btn dark text @click="message.snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-dialog v-model="assignConsultantDialog" scrollable max-width="600px">
      <v-card>
        <v-card-title>Assign consultant</v-card-title>
        <v-divider></v-divider>

        <v-card-text>
          <v-form ref="formUpdateGroupEvent">
            <v-select
              v-model="eventGroupSlot.assignedTo"
              :items="staff"
              :multiple="true"
              label="Assign to..."
            ></v-select>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="blue darken-1"
            text
            @click="assignConsultantDialog = false"
            class="hp--btn"
            >Close</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            class="hp--btn"
            @click="saveConsultant"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-container>
      <Header />
      <v-overlay :value="loader">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-card class="mx-auto" max-width="1100">
        <v-toolbar flat>
          <v-toolbar-title class="grey--text">Upcoming events</v-toolbar-title>
          <div class="flex-grow-1"></div>
          <v-text-field
            class="mt-7"
            v-model="search"
            label="Search"
            required
            append-icon="search"
          ></v-text-field>
        </v-toolbar>
        <v-divider></v-divider>
        <v-card-text>
          <div v-for="event in filteredData" :key="event.eventSlotGroupId">
            <v-layout row wrap class="ma-1">
              <v-flex xs12 sm12 md1 lg1 xl1>
                <v-tooltip
                  v-for="assigned in event.assignedTo"
                  :key="assigned"
                  right
                >
                  <template v-slot:activator="{ on }">
                    <v-avatar color="red" size="34" v-on="on" class="ma-2">
                      <span class="white--text headline">{{
                        getInitialsByEmail(assigned)
                      }}</span>
                    </v-avatar>
                  </template>
                  <span>Assigned to {{ getNameByEmail(assigned) }}</span>
                </v-tooltip>
              </v-flex>
              <v-flex xs12 sm12 md3 lg3 xl3>
                <div class="caption grey--text">Company/Event</div>
                <div class="black--text">
                  {{ event.company }} - {{ event.event }}
                </div>
              </v-flex>
              <v-flex xs12 sm12 md1 lg1 xl1>
                <div class="caption grey--text">Code</div>
                <div class="black--text">{{ event.code }}</div>
              </v-flex>
              <v-flex xs12 sm12 md1 lg1 xl1>
                <div class="caption grey--text">Location</div>
                <div class="black--text">{{ event.location }}</div>
              </v-flex>
              <v-flex xs12 sm12 md1 lg1 xl1>
                <div class="caption grey--text">Date</div>
                <div class="black--text">
                  {{ event.date | moment("DD/MM/YYYY") }}
                </div>
              </v-flex>
              <v-flex xs12 sm12 md1 lg1 xl1>
                <div class="caption grey--text">Room</div>
                <div class="black--text">{{ event.room }}</div>
              </v-flex>

              <v-flex xs12 sm12 md1 lg1 xl1>
                <div class="caption grey--text">Active</div>
                <v-switch
                  v-model="event.active"
                  inset
                  class="pt-0 mt-1 ml-1"
                  @click="setActive(event)"
                  color="error"
                ></v-switch>
              </v-flex>

              <v-flex xs12 sm12 md2 lg2 xl2>
                <v-btn-toggle color="info" v-model="event.status">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        value="Live"
                        v-on="on"
                        @click="saveEventStatus(event, 'Live')"
                      >
                        <v-icon color="green">mdi-play</v-icon>
                      </v-btn>
                    </template>
                    <span>Live</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        value="Paused"
                        v-on="on"
                        @click="saveEventStatus(event, 'Paused')"
                      >
                        <v-icon color="orange">mdi-pause</v-icon>
                      </v-btn>
                    </template>
                    <span>Paused</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        value="Draft"
                        v-on="on"
                        @click="saveEventStatus(event, 'Draft')"
                      >
                        <v-icon color="black">mdi-stop</v-icon>
                      </v-btn>
                    </template>
                    <span>Draft</span>
                  </v-tooltip>
                </v-btn-toggle>
              </v-flex>

              <v-flex xs12 sm12 md1 lg1 xl1>
                <div class="float-right">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        fab
                        dark
                        x-small
                        color="purple"
                        @click="openConsultantDialog(event)"
                        class="ma-2"
                        v-on="on"
                      >
                        <v-icon dark>people</v-icon>
                      </v-btn>
                    </template>
                    <span>Assign User</span>
                  </v-tooltip>
                </div>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
          </div>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { API, graphqlOperation } from "aws-amplify";
import { hpUser } from "../classes/hpUser";
import * as mutations from "./../graphql/mutations";
import Header from "../components/Header.vue";
import { Event } from "../classes/Event";
import moment from "moment";
import _ from "lodash";
export default {
  components: {
    Header
  },
  data() {
    return {
      loader: false,
      events: [],
      search: "",
      nextToken: null,
      hpUser: [],
      assignConsultantDialog: false,
      eventGroupSlot: { staff: {} },
      message: {
        snackbar: false,
        snackbarText: "",
        snackbarTimeout: 3000
      }
    };
  },
  async created() {
    this.loader = true;
    this.getUsers();

    let events = await this.nextRecord();
    while (this.nextToken !== null) {
      let nextEvents = await this.nextRecord();
      events.push(...nextEvents);
    }
    events.map(event => {
      if (event.eventLocation) {
        if (event.eventLocation.event.eventCompany.isDeleted === 0) {
          this.events.push({
            id: event.eventLocation.event.id,
            eventSlotGroupId: event.id,
            date: event.date,
            room: event.room,
            company: event.eventLocation.event.eventCompany.name,
            event: event.eventLocation.event.name,
            code: event.eventLocation.event.code,
            location: event.eventLocation.town,
            status: event.eventLocation.event.status,
            assignedTo: JSON.parse(event.assignedTo),
            active: event.active
          });
        }
      }
    });
    this.events = _.orderBy(this.events, "date", "asc");
    this.loader = false;
  },
  methods: {
    async nextRecord() {
      const date = moment()
        .subtract(1, "day")
        .format("YYYY-MM-DD");
      let nextEvents = await new Event().getEventsByEventSlotGroups({
        date: date,
        nextToken: this.nextToken
      });

      this.nextToken = nextEvents.nextToken;
      return nextEvents.items;
    },
    async getUsers() {
      let that = this;
      that.hpUser = [];
      that.staff = [];
      let hpUserObj = new hpUser();
      that.hpUser = await hpUserObj.getUsers();
      that.hpUser = _.orderBy(that.hpUser, "firstName", "asc");
      that.hpUser.forEach(function(user) {
        that.staff.push({
          text: user.firstName + " " + user.lastName,
          value: user.email
        });
      });
    },
    getNameByEmail(email) {
      let staff = this.hpUser.filter(staff => staff.email === email);
      if (staff[0]) {
        return staff[0].firstName + " " + staff[0].lastName;
      }
    },
    getInitialsByEmail(email) {
      let staff = this.hpUser.filter(staff => staff.email === email);
      if (staff[0]) {
        return staff[0].firstName.charAt(0) + staff[0].lastName.charAt(0);
      }
    },
    openConsultantDialog(event) {
      this.eventGroupSlot.id = event.eventSlotGroupId;
      this.eventGroupSlot.assignedTo = event.assignedTo;
      this.assignConsultantDialog = true;
    },
    saveConsultant() {
      if (this.$refs.formUpdateGroupEvent.validate()) {
        API.graphql(
          graphqlOperation(mutations.updateEventSlotGroup, {
            input: {
              id: this.eventGroupSlot.id,
              assignedTo: JSON.stringify(this.eventGroupSlot.assignedTo)
            }
          })
        ).then(result => {
          const index = this.events.findIndex(
            grp => grp.eventSlotGroupId === result.data.updateEventSlotGroup.id
          );
          this.events[index].assignedTo = JSON.parse(
            result.data.updateEventSlotGroup.assignedTo
          );
          this.assignConsultantDialog = false;
          this.showSuccessMessage("New user(s) assigned");
        });
      }
    },
    saveEventStatus(event, status) {
      API.graphql(
        graphqlOperation(mutations.updateEvent, {
          input: {
            id: event.id,
            status: status
          }
        })
      ).then(result => {
        const updateEvent = result.data.updateEvent;
        const index = this.events.findIndex(e => updateEvent.id === e.id);
        Object.assign(this.events[index], updateEvent);
        this.showSuccessMessage(
          `${updateEvent.name} status changed to ${status}`
        );
      });
    },
    setActive(event) {
      API.graphql(
        graphqlOperation(mutations.updateEventSlotGroup, {
          input: {
            id: event.eventSlotGroupId,
            active: event.active
          }
        })
      ).then(result => {
        const updateEventSlotGroup = result.data.updateEventSlotGroup;
        const index = this.events.findIndex(
          e => updateEventSlotGroup.id === e.eventSlotGroupId
        );
        Object.assign(this.events[index].active, updateEventSlotGroup.active);
        if (event.active) {
          this.showSuccessMessage(
            `${updateEventSlotGroup.eventLocation.event.name} is active`
          );
        } else {
          this.showSuccessMessage(
            `${updateEventSlotGroup.eventLocation.event.name} is NOT active`
          );
        }
      });
    },
    showSuccessMessage(message) {
      this.message.snackbarText = message;
      this.message.snackbar = true;
    }
  },
  computed: {
    filteredData() {
      if (this.search) {
        return this.events.filter(
          event =>
            (event.code &&
              event.code.toLowerCase().indexOf(this.search.toLowerCase()) !=
                -1) ||
            (event.company &&
              event.company.toLowerCase().indexOf(this.search.toLowerCase()) !=
                -1) ||
            (event.location &&
              event.location.toLowerCase().indexOf(this.search.toLowerCase()) !=
                -1) ||
            (event.room &&
              event.room.toLowerCase().indexOf(this.search.toLowerCase()) != -1)
        );
      }
      return this.events;
    }
  }
};
</script>
